// Push notification configuration
// VAPID keys are used for Web Push authentication
// The public key is safe to include in client code

export const PUSH_CONFIG = {
  // VAPID public key for Web Push authentication
  VAPID_PUBLIC_KEY: 'BMmP-O9EqgeEIDtb74Y8v9reKO6s_bTNdM5TFuedq-FvRQ6S9fpizLBNAB-EcV1o_zmA_z-qf28D4FEWMqWcaWs',
};
